/* global axios */
import ApiClient from './ApiClient';

class MessageDraftsAPI extends ApiClient {
  constructor() {
    super('message_drafts', { accountScoped: true });
  }

  index() {
    return axios.get(this.url);
  }

  create({
    publicContent,
    privateContent,
    contactId,
    inboxId,
    subject,
    ccEmails,
    bccEmails,
    toEmails,
    fromEmail,
  } = {}) {
    const data = {};
    if (publicContent !== undefined) data.public_content = publicContent;
    if (privateContent !== undefined) data.private_content = privateContent;
    if (contactId !== undefined) data.contact_id = contactId;
    if (inboxId !== undefined) data.inbox_id = inboxId;
    if (subject !== undefined) data.subject = subject;
    if (ccEmails !== undefined) data.cc_emails = ccEmails;
    if (bccEmails !== undefined) data.bcc_emails = bccEmails;
    if (toEmails !== undefined) data.to_emails = toEmails;
    if (fromEmail !== undefined) data.from_email = fromEmail;
    return axios.post(this.url, data);
  }

  show(draftId) {
    return axios.get(`${this.url}/${draftId}`);
  }

  update(
    draftId,
    {
      publicContent,
      privateContent,
      contactId,
      inboxId,
      subject,
      ccEmails,
      bccEmails,
      toEmails,
      fromEmail,
    } = {}
  ) {
    const data = {};
    if (publicContent !== undefined) data.public_content = publicContent;
    if (privateContent !== undefined) data.private_content = privateContent;
    if (contactId !== undefined) data.contact_id = contactId;
    if (inboxId !== undefined) data.inbox_id = inboxId;
    if (subject !== undefined) data.subject = subject;
    if (ccEmails !== undefined) data.cc_emails = ccEmails;
    if (bccEmails !== undefined) data.bcc_emails = bccEmails;
    if (toEmails !== undefined) data.to_emails = toEmails;
    if (fromEmail !== undefined) data.from_email = fromEmail;
    return axios.patch(`${this.url}/${draftId}`, data);
  }

  destroy(draftId) {
    return axios.delete(`${this.url}/${draftId}`);
  }

  forward(messageId) {
    return axios.post(`${this.url}/forward`, { message_id: messageId });
  }

  addAttachmentFile(draftId, file, { signal, isPrivate } = {}) {
    const formData = new FormData();
    formData.append('attachment', file);
    if (isPrivate) formData.append('private', true);
    return axios.post(`${this.url}/${draftId}/attachments`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      signal,
    });
  }

  addAttachmentBlob(draftId, blobSignedId, { signal, isPrivate } = {}) {
    return axios.post(
      `${this.url}/${draftId}/attachments`,
      { blob_signed_id: blobSignedId, private: isPrivate },
      { signal }
    );
  }

  removeAttachment(draftId, attachmentId) {
    return axios.delete(`${this.url}/${draftId}/attachments/${attachmentId}`);
  }
}

export default new MessageDraftsAPI();
